module.exports = __webpack_public_path__ + "static/media/workers.4ebec627.jpg";